import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class DataHandlerService {
  private personListSubject = new BehaviorSubject<any>(null);
  private applicantForRemovalSubject = new BehaviorSubject<any>(null);
  private smsfSubject = new BehaviorSubject<any>(null);
  private borrowerTypeSubject = new BehaviorSubject<any>(null);
  private borrowerCountSubject = new BehaviorSubject<any>(null);
  private autoLoanAmountSubject = new BehaviorSubject<any>(null);
  private dialDownSubject = new BehaviorSubject<any>(null);
  private bidCompliantSubject = new BehaviorSubject<any>(null);
  private dialDownDisabledSubject = new BehaviorSubject<any>(null);
  private isRetailSubject = new BehaviorSubject<any>(null);
  private securityTrustSubject = new BehaviorSubject<any>(null);
  private securityTrustBorrowerCountSubject = new BehaviorSubject<any>(null);
  private mainBorrowerTypeSubject = new BehaviorSubject<any>(null);
  private confirmedComponentSubject = new BehaviorSubject<any>(null);
  private isHomeownerSubject = new BehaviorSubject<any>(null);
  private ndiPassSubject = new BehaviorSubject<any>(null);
  public ndiPass = this.ndiPassSubject.asObservable();

  private pndiPassSubject = new BehaviorSubject<any>(null);

  private ndiResultsSubject = new BehaviorSubject<any>(null);

  private securedAssetSubject = new BehaviorSubject<any>(null);
  private vehicleTypeSubject = new BehaviorSubject<any>(null);
  private realEstateCountWithoutNasSubject = new BehaviorSubject<any>(null);
  private productCategorySubject = new BehaviorSubject<any>(null);
  private originatorChannelSubject = new BehaviorSubject<any>(null);
  public originatorChannelData = this.originatorChannelSubject.asObservable();

  private feesSubject = new BehaviorSubject<any>(null);
  public feesData = this.feesSubject.asObservable();

  private assetSubject = new BehaviorSubject<any>(null);
  public assetData = this.assetSubject.asObservable();

  sendAssetChange() {
    this.assetSubject.next(true);
    return true;
  }

  getAssetChange(): Observable<any> {
    return this.assetSubject.asObservable();
  }

  sendProductCategory(data: any) {
    this.productCategorySubject.next(data);
    return true;
  }

  getProductCategory(): Observable<any> {
    return this.productCategorySubject.asObservable();
  }

  sendRealEstateCountWithoutNas(data: any) {
    this.realEstateCountWithoutNasSubject.next(data);
    return true;
  }

  getRealEstateCountWithoutNas(): Observable<any> {
    return this.realEstateCountWithoutNasSubject.asObservable();
  }

  setApplicationFee(data: any) {
    this.feesSubject.next(data);
    return true;
  }

  getApplicationFee(): Observable<any> {
    return this.feesSubject.asObservable();
  }

  setOriginatorChannel(data: any) {
    this.originatorChannelSubject.next(data);
    return true;
  }

  getOriginatorChannel(): Observable<any> {
    return this.originatorChannelSubject.asObservable();
  }

  sendVehicleType(data: any) {
    this.vehicleTypeSubject.next(data);
    return true;
  }

  getVehicleType(): Observable<any> {
    return this.vehicleTypeSubject.asObservable();
  }

  getVehicleTypeValue(): Observable<any> {
    return this.vehicleTypeSubject.getValue();
  }

  setNdiPassFlag(data: any) {
    this.ndiPassSubject.next(data);
  }

  getNdiPassFlag(): Observable<any> {
    return this.ndiPassSubject.asObservable();
  }

  setPndiPassFlag(data: any) {
    this.pndiPassSubject.next(data);
  }

  getPndiPassFlag(): Observable<any> {
    return this.pndiPassSubject.asObservable();
  }

  setNdiFlags(data: any) {
    this.ndiResultsSubject.next(data);
  }

  getNdiFlags(): Observable<any> {
    return this.ndiResultsSubject.asObservable();
  }

  setSecuredAsset(data: any) {
    this.securedAssetSubject.next(data);
    return true;
  }

  getSecuredAsset(): Observable<any> {
    return this.securedAssetSubject.asObservable();
  }

  sendIsRetailFlag(data: any) {
    this.isRetailSubject.next(data);
    return true;
  }

  getIsRetailFlag(): Observable<any> {
    return this.isRetailSubject.asObservable();
  }

  getConfirmedComponent(): Observable<any> {
    return this.confirmedComponentSubject.asObservable();
  }

  sendIsHomeOwner(data: any) {
    this.isHomeownerSubject.next(data);
    return true;
  }

  getIsHomeOwner(): Observable<any> {
    return this.isHomeownerSubject.asObservable();
  }

  sendDialDownData(data: any) {
    this.dialDownSubject.next(data);
    return true;
  }

  getDialDownData(): Observable<any> {
    return this.dialDownSubject.asObservable();
  }

  sendBidCompliantFlag(data: any) {
    this.bidCompliantSubject.next(data);
    return true;
  }

  getBidCompliantFlag(): Observable<any> {
    return this.bidCompliantSubject.asObservable();
  }

  sendDialDownDisabledFlag(data: any) {
    this.dialDownDisabledSubject.next(data);
    return true;
  }

  getDialDownDisabledFlag(): Observable<any> {
    return this.dialDownDisabledSubject.asObservable();
  }

  sendAutoLoanAmountData(data: any) {
    this.autoLoanAmountSubject.next(data);
    return true;
  }

  getAutoLoanAmountData(): Observable<any> {
    return this.autoLoanAmountSubject.asObservable();
  }

  sendBorrowerTypeData(data: any) {
    this.borrowerTypeSubject.next(data);
    return true;
  }

  getBorrowerTypeData(): Observable<any> {
    return this.borrowerTypeSubject.asObservable();
  }

  sendBorrowerCountData(data: any) {
    this.borrowerCountSubject.next(data);
    return true;
  }

  getBorrowerCountData(): Observable<any> {
    return this.borrowerCountSubject.asObservable();
  }

  sendPersonListData(data: any) {
    this.personListSubject.next(data);
    return true;
  }

  sendApplicantForRemoval(index: number) {
    this.applicantForRemovalSubject.next(index);
    return true;
  }

  getApplicantForRemoval(): Observable<any> {
    return this.applicantForRemovalSubject.asObservable();
  }

  sendSmsfData(data: any) {
    this.smsfSubject.next(data);
    return true;
  }

  getSmsfData(): Observable<any> {
    return this.smsfSubject.asObservable();
  }

  sendSecurityTrustBorrowerType(data: any) {
    this.securityTrustSubject.next(data);
    return true;
  }

  getSecurityTrustBorrowerType(): Observable<any> {
    return this.securityTrustSubject.asObservable();
  }

  sendSecurityTrustBorrowerCount(data: any) {
    this.securityTrustBorrowerCountSubject.next(data);
    return true;
  }

  getSecurityTrustBorrowerCount(): Observable<any> {
    return this.securityTrustBorrowerCountSubject.asObservable();
  }

  sendMainBorrowerType(data: any) {
    this.mainBorrowerTypeSubject.next(data);
    return true;
  }

  getMainBorrowerType(): Observable<any> {
    return this.mainBorrowerTypeSubject.asObservable();
  }
}
